(function() {
  const LOCAL_STORAGE_SPONSOR_KEY = "sponsor_code";
  const LOCAL_STORAGE_COUNTRY_KEY = "country_code";
  const BASE_URL = `${window.location.origin}/apps/jot-connector`;
  //const BASE_URL = 'https://supercolossal-elmira-megaphonically.ngrok-free.dev/shopify-proxy';
  const LOOKUP_URL = `${BASE_URL}/partner-lookup`;
  const LOOKUP_BY_URL = `${BASE_URL}/partner-lookup-by`;
  const SPONSOR_CONTACT_URL = `${BASE_URL}/sponsor-contact`;

  function log(...args) {
    // comment line before release
    console.log(...args);
  }

  function setSponsorCode(sponsorCode) {
    if(sponsorCode == null || sponsorCode == undefined || !sponsorCode) {
      log('remove sponsor code')
      localStorage.removeItem(LOCAL_STORAGE_SPONSOR_KEY);
      return;
    }

    try {
      log('set sponsor code to', sponsorCode);
      localStorage.setItem(LOCAL_STORAGE_SPONSOR_KEY, sponsorCode);
    } catch (error) {
      log(error)
    }
  }
  
  function getSponsorCode() {
    try {
      return localStorage.getItem(LOCAL_STORAGE_SPONSOR_KEY);
    } catch {
      return null;
    }
  }

  function removeSponsorCode() {
    try {
      localStorage.removeItem(LOCAL_STORAGE_SPONSOR_KEY);
    } catch {}
  }

  function trySetSponsorCodeFromUrl() {
    const searchParams = new URLSearchParams(window.location.search)
    const sponsorCode = searchParams.get('sponsor');

    log('sponsor code from url', sponsorCode);

    if(!sponsorCode) return;

    setSponsorCode(sponsorCode);
  }

  function setStoredCountry(code) {
    if(code == null || code == undefined || !code) {
      log('remove country code')
      localStorage.removeItem(LOCAL_STORAGE_SPONSOR_KEY);
      return;
    }

    try {
      localStorage.setItem(LOCAL_STORAGE_COUNTRY_KEY, code);
    } catch (e) {}
  }

  function getStoredCountry() {
    try {
      const value = localStorage.getItem(LOCAL_STORAGE_COUNTRY_KEY);
      return !!value ? value : null;
    } catch (e) {
      return null;
    }
  }

  function removeStoredCountry() {
    try {
      localStorage.removeItem(LOCAL_STORAGE_COUNTRY_KEY);
    } catch (e) {}
  }
 
  async function fetchSponsor(code) {
    if(!code) {
      throw new Error('sponsor lookup failed');
    }

    const url = new URL(LOOKUP_URL);
    url.searchParams.set('sponsor', code);

    const res = await fetch(url.toString(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 
        accept: 'application/json',
        'ngrok-skip-browser-warning': '1'
      },
    });

    if (!res.ok) throw new Error('Sponsor lookup failed: ' + res.status);

    const data = await res.json();
    if (!data || !data.sponsor || !data.name) throw new Error('Invalid sponsor response');
    return data;
  }

  async function fetchSponsorsByName(name) {
    const url = new URL(LOOKUP_BY_URL);
    url.searchParams.set('name', name);

    const res = await fetch(url.toString(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        accept: 'application/json',
        'ngrok-skip-browser-warning': '1',
      },
    });

    if (!res.ok) throw new Error('Search failed: ' + res.status);

    const data = await res.json();
    if (!Array.isArray(data)) throw new Error('Invalid search response');
    return data;
  }

  async function sendContactMe(payload) {
    const res = await fetch(SPONSOR_CONTACT_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': '1',
      },
      body: JSON.stringify(payload),
    });
    
    if (!res.ok) throw new Error('Send failed: ' + res.status);

    return res;
  }

  window.jot = window.jot || {};
  window.jot.utils = {
    setSponsorCode,
    getSponsorCode,
    removeSponsorCode,
    trySetSponsorCodeFromUrl,
    setStoredCountry,
    getStoredCountry,
    removeStoredCountry,
    fetchSponsor,
    fetchSponsorsByName,
    sendContactMe
  };    
})();